<lx-loading-spinner i18n-message message="Loading..." [loading]="loading" shadingColor="rgba(0,0,0,0.5)"></lx-loading-spinner>

<lx-section-template [columns]="columns" [sectionTitle]="title">
  <div class="price-request-course-form__form-group">
    <lx-language-selector
      class="form-field__validated-selector-padding"
      label="Language"
      i18n-label
      lxCourseDetailsLogging="languageCode"
      [value]="(quoteInput$ | async)?.languageCode"
      [required]="true"
      [buttonView]="false"
      (valueChange)="processSelectedLanguageChange($event)"
      [lxGAClickEvent]="languageSelectorClickEvent$ | async"
      data-qa="qt-language-selector"
    ></lx-language-selector>
  </div>

  <div class="price-request-course-form__form-group">
    <lx-course-type-selector
      class="qt-form-section__start-new-line form-field__validated-selector-padding"
      label="Program"
      i18n-label
      lxCourseDetailsLogging="courseType"
      [value]="(quoteInput$ | async)?.courseType"
      [codes]="availableCourseTypes"
      [required]="true"
      [ageGroup]="ageGroup"
      [disabled]="!(quoteInput$ | async)?.languageCode"
      [buttonView]="false"
      [schoolCompany]="'ESL'"
      [iconValidation]="true"
      (itemChange)="processSelectedCourseTypeChanged($event)"
      [attr.data-qa]="'qt-course-type-selector'"
    ></lx-course-type-selector>
  </div>

  <div class="price-request-course-form__form-group">
    <lx-destination-country-selector
      class="form-field__validated-selector-padding"
      label="Country"
      i18n-label
      lxCourseDetailsLogging="country"
      [value]="(quoteInput$ | async)?.countryCode"
      [autofill]="!!(quoteInput$ | async)?.courseType"
      [disabled]="!(quoteInput$ | async)?.courseType"
      [required]="true"
      [countries]="filteredCountries"
      [buttonView]="false"
      [iconValidation]="true"
      (itemChange)="processSelectedCountryChanged($event)"
      data-qa="qt-country-selector"
    ></lx-destination-country-selector>
  </div>

  <div class="price-request-course-form__form-group">
    <lx-city-selector
      class="form-field__validated-selector-padding"
      label="City"
      i18n-label
      lxCourseDetailsLogging="destinationCity"
      [value]="(quoteInput$ | async)?.destinationCity?.code"
      [autofill]="!!(quoteInput$ | async)?.countryCode"
      [disabled]="!(quoteInput$ | async)?.countryCode"
      [required]="true"
      [buttonView]="false"
      [countryCode]="(quoteInput$ | async)?.countryCode"
      [availableCities]="availableCities"
      (itemChange)="processSelectedDestinationCityChanged($event)"
      data-qa="qt-city-selector"
    ></lx-city-selector>
  </div>
</lx-section-template>

<lx-section-template [columns]="2">
  <div>
    <!-- Show Date List Selector when dateListEnabled is true -->
    <lx-date-list-selector
      *ngIf="dateListEnabled"
      class="form-field__validated-selector-padding"
      label="Start date"
      i18n-label
      placeholder="— Please select  —"
      i18n-placeholder
      lxCourseDetailsLogging="startDate"
      [value]="(quoteInput$ | async)?.startDate"
      [required]="true"
      [disabled]="!(quoteInput$ | async)?.courseType || !(quoteInput$ | async)?.destinationCity || !availableStartDates?.length"
      [iconValidation]="true"
      [dates]="availableStartDates"
      (valueChange)="handleStartDateSelection($event)"
      data-qa="qt-start-date-selector"
    ></lx-date-list-selector>

    <!-- Show Date Picker when dateListEnabled is false (default) -->
    <lx-date-picker-field
      *ngIf="!dateListEnabled"
      class="form-field__validated-selector-padding"
      label="Start date"
      i18n-label
      placeholder="— Please select  —"
      i18n-placeholder
      lxCourseDetailsLogging="startDate"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [required]="true"
      [disabled]="!(quoteInput$ | async)?.courseType || !(quoteInput$ | async)?.destinationCity || !disabledDates?.length"
      [dateValue]="(quoteInput$ | async)?.startDate"
      [defaultDate]="firstAvailableDate"
      [disabledDates]="disabledDates"
      [iconValidation]="true"
      [showCalendarIcon]="true"
      (dateChanged)="processSelectedStartDateChange($event)"
      data-qa="qt-start-date-field"
    ></lx-date-picker-field>
  </div>
  <div class="price-request-course-form__form-group">
    <lx-weeks-selector
      class="form-field__validated-selector-padding"
      label="Duration"
      i18n-label
      lxCourseDetailsLogging="tuitionWeeks"
      [value]="(quoteInput$ | async)?.tuitionWeeks"
      [required]="true"
      [disabled]="!(quoteInput$ | async)?.startDate || !(quoteInput$ | async)?.courseType"
      [iconValidation]="true"
      [availableWeeksValues]="availableWeeks"
      (valueChange)="applyInputChangeToStore('tuitionWeeks', $event)"
      [attr.data-qa]="'qt-duration-field'"
    ></lx-weeks-selector>
  </div>
</lx-section-template>

<lx-section-template [columns]="columns">
  <div class="price-request-course-form__form-group">
    <lx-form-field-selector
      class="form-field__validated-selector-padding"
      label="Accommodation"
      i18n-label
      valueExpr="code"
      lxCourseDetailsLogging="accommodationType"
      [required]="true"
      [value]="selectedAccommodationType?.code"
      [itemList]="accommodationTypes"
      [disabled]="!(quoteInput$ | async)?.startDate || !(quoteInput$ | async)?.tuitionWeeks"
      [iconValidation]="true"
      (itemChange)="processSelectedAccommodationTypeChanged($event)"
      data-qa="pr-accommodation-type-field"
    ></lx-form-field-selector>
  </div>
</lx-section-template>

<lx-section-template [columns]="1">
  <lx-form-field
    class="qt-form-section__double-column-span form-field__no-validation"
    label="Tell us more about your objective and needs if you’d be interested in other programmes or destinations."
    i18n-label
    [small]="true"
    [isValid]="true"
    [required]="false"
    [disabled]="!(quoteInput$ | async)?.startDate"
    [iconValidation]="true"
    data-qa="pr-customer-project-field"
  >
    <textarea
      class="qt-form-section__textarea"
      pInputTextarea
      lxCourseDetailsLogging="specialRequests"
      lxCourseDetailsLoggingFocusOut="true"
      [(ngModel)]="specialRequests"
      [autoResize]="false"
      (ngModelChange)="setSpecialRequests($event)"
    ></textarea>
  </lx-form-field>
</lx-section-template>
